import script from "./SideBarNav.vue?vue&type=script&setup=true&lang=js"
export * from "./SideBarNav.vue?vue&type=script&setup=true&lang=js"

import "./SideBarNav.vue?vue&type=style&index=0&id=5fc8b649&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fc8b649"]])

export default __exports__